import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timeSinceLogin'
,
  standalone: false
})
export class TimeSinceLoginPipe implements PipeTransform {
  transform(loginTime: string): string {
    if (!loginTime) return '';

    const now = moment.tz(new Date(), 'Asia/Kolkata').toDate();
    //const now = new Date();

    const loginDate = moment.tz(loginTime, 'Asia/Kolkata').toDate();
    //new Date(loginTime);

    // Calculate the difference in milliseconds
    const diffMs = now.getTime() - loginDate.getTime();

    // Convert milliseconds to human-readable format
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    // Construct the duration string
    let duration = '';
    if (days > 0) {
      duration += days + 'd ';
    }
    if (hours > 0) {
      duration += hours + 'h ';
    }
    duration += minutes + 'm';

    return duration;
  }
}
